import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { BoardAccess } from '../../lib/api';
import type { BoardVersion } from '../../lib/version-types';
import { History } from 'lucide-react';
import { IconButton } from '../../ui';
import { Icon } from '../../ui/icons';
import { HistoryPanel } from './HistoryPanel';
import { usePaletteCommands } from '../palette/registry';

/**
 * Opens the version history (viewer and up) from an icon at the right end of the top bar (P16-3); choosing a version hands it to the preview and closes the panel. `bare`
 * (phones, P5f): no button, the main menu's Board › History opens it through the palette command.
 */
export function HistoryButton({ boardId, access, onPreview, bare }: { boardId: string; access: BoardAccess; onPreview: (v: BoardVersion) => void; bare?: boolean }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const button = useRef<HTMLButtonElement>(null);
  usePaletteCommands(() => [{ id: 'history', label: t('history.button'), group: 'board', keywords: ['versions', 'historique', 'restore', 'restaurer'], run: () => setOpen(true) }]);
  return (
    <>
      {!bare && (
        <IconButton ref={button} label={t('history.button')} aria-expanded={open} onClick={() => setOpen((o) => !o)} icon={<Icon icon={History} size={16} />} />
      )}
      {open && (
        <HistoryPanel
          boardId={boardId}
          access={access}
          toggle={button}
          onClose={() => setOpen(false)}
          onPreview={(v) => {
            setOpen(false);
            onPreview(v);
          }}
        />
      )}
    </>
  );
}
